import SidebarCssVariable from "./SidebarCssVariable";
import tinycolor from "tinycolor2";
import type { CustumizationUserInfo } from "@/types/LoginInfo";

// check sidebar.less
// ex: variableName = " --home-sidebar-bg-color"
// value = "green"
export const setCSSVariable = (variableName: string, value: string): void => {
  document.documentElement.style.setProperty(variableName, value);
};

export const getContrastColor = (colorValue: string): string | undefined => {
  const color = tinycolor(colorValue);
  if (color.isDark()) {
    const lighten = color.lighten(10).toString();
    return lighten;
  } else if (color.isLight()) {
    const darken = color.darken(10).toString();
    return darken;
  }
};

export const setSideBarColors = (data?: CustumizationUserInfo): void => {
  // home theme
  setCSSVariable(
    SidebarCssVariable.homeSideBarColor,
    data?.homeSideBarColor
      ? data?.homeSideBarColor
      : SidebarCssVariable.homeSideBarColorDefault
  );

  setCSSVariable(
    SidebarCssVariable.homeSideBarSectionFontColor,
    data?.homeSideBarSectionFontColor
      ? data?.homeSideBarSectionFontColor
      : SidebarCssVariable.homeSideBarSectionFontColorDefault
  );
  setCSSVariable(
    SidebarCssVariable.homeSideBarFontColor,
    data?.homeSideBarFontColor
      ? data?.homeSideBarFontColor
      : SidebarCssVariable.homeSideBarFontColorDefault
  );

  setCSSVariable(
    SidebarCssVariable.homeSideBarSelectedColor,
    data?.homeSideBarSelectedColor
      ? data?.homeSideBarSelectedColor
      : SidebarCssVariable.homeSideBarSelectedColorDefault
  );

  setCSSVariable(
    SidebarCssVariable.homeFooterBackgroundColor,
    data?.homeFooterBackgroundColor
      ? data?.homeFooterBackgroundColor
      : SidebarCssVariable.homeFooterBackgroundColorDefault
  );

  setCSSVariable(
    SidebarCssVariable.homeFooterButtonSelectedColor,
    data?.homeFooterButtonSelectedColor
      ? data?.homeFooterButtonSelectedColor
      : SidebarCssVariable.homeFooterButtonSelectedColorDefault
  );

  // admin theme
  setCSSVariable(
    SidebarCssVariable.adminSideBarColor,
    data?.adminSideBarColor
      ? data?.adminSideBarColor
      : SidebarCssVariable.adminSideBarColorDefault
  );

  setCSSVariable(
    SidebarCssVariable.adminSideBarSectionFontColor,
    data?.adminSideBarSectionFontColor
      ? data?.adminSideBarSectionFontColor
      : SidebarCssVariable.adminSideBarSectionFontColorDefault
  );
  setCSSVariable(
    SidebarCssVariable.adminSideBarFontColor,
    data?.adminSideBarFontColor
      ? data?.adminSideBarFontColor
      : SidebarCssVariable.adminSideBarFontColorDefault
  );

  setCSSVariable(
    SidebarCssVariable.adminSideBarSelectedColor,
    data?.adminSideBarSelectedColor
      ? data?.adminSideBarSelectedColor
      : SidebarCssVariable.adminSideBarSelectedColorDefault
  );

  setCSSVariable(
    SidebarCssVariable.adminFooterBackgroundColor,
    data?.adminFooterBackgroundColor
      ? data?.adminFooterBackgroundColor
      : SidebarCssVariable.adminFooterBackgroundColorDefault
  );

  setCSSVariable(
    SidebarCssVariable.adminFooterButtonSelectedColor,
    data?.adminFooterButtonSelectedColor
      ? data?.adminFooterButtonSelectedColor
      : SidebarCssVariable.adminFooterButtonSelectedColorDefault
  );
};
